module.exports = __webpack_public_path__ + "img/tcndxq_img2_gray-6.67daafc5.png";